import UIkit from 'uikit';

import initMainNavigation from './mainNavigation';
import initInfographicCards from './infographicCards';
import initMegamenu from './megamenu';
import initAccordionCards from './accordion-cards';
import initNewsSlideshow from './news-slideshow';
import initAnimations from './animations';
import initAutotyping from './autotyping';
import initRolodexSlideshow from './rolodex-slideshow';
import phiniaIcons from './uikit-iconslib';
import './fixed-topright-element';

window.UIkit = UIkit;

window.UIkitIcons = window.UIkitIcons || [];

window.UIkit.icon.add(phiniaIcons);

window.UIkitIcons = window.UIkitIcons.concat(Object.keys(phiniaIcons));

window.labels = {};
window.addLabels = function (labels) {
  if (!labels) return;
  window.labels = { ...window.labels, ...labels };
};

window.l = function (k) {
  k = k.toString().trim();
  /* eslint-disable */
  if (!window.labels.hasOwnProperty(k)) {
    // console.log('Missing label', k)
    return `#ResourceNotFound: ${k}#`;
  }
  return window.labels[k];
};
const $ = (css, parent = document) => parent.querySelector(css);
const $$ = (css, parent = document) => parent.querySelectorAll(css);

$$('.switcher').forEach(el => {
  let container = el.closest('.uk-section');
  let itemsContainer = container.querySelector('.switcher-items');
  if (!itemsContainer) return;

  let tabs = itemsContainer.querySelectorAll('.uk-slider-container');
  let tabsIndex = 0;
  let removedTabs = 0;
  if (tabs.length > 0) {
    tabs.forEach(tab => {
      let buttons = el.querySelectorAll('.uk-button');
      let currentButton = buttons[tabsIndex];
      removedTabs++;
      if (buttons.length >= tabsIndex) {
        currentButton.style.display = 'none';
        if (currentButton.classList.contains('uk-active')) {
          currentButton.classList.remove('uk-active');
        }
        if (buttons.length > tabsIndex + 1) {
          buttons[tabsIndex + 1].classList.add('uk-active');
        }
      }

      tabsIndex++;
    });

    if (removedTabs == tabsIndex) {
      container.style.display = 'none';
    }
  }

  let uuid = btoa(Math.random().toString()).substr(0, 10);

  itemsContainer.setAttribute('data-uuid', uuid);

  UIkit.switcher(el, {
    toggle: el.dataset.switcherToggle,
    connect: '[data-uuid="' + uuid + '"]',
    swiping: false,
  });

  itemsContainer.classList.add('uk-switcher');
  itemsContainer.classList.remove('switcher-items-tmp');
});

const calcOverlayCenteredCardPadding = () => {
  const gridContainers = document.querySelectorAll('.uk-grid');

  if (!gridContainers) return;

  const gridsWithCardOverlay = Array.from(gridContainers).filter(grid => {
    return grid.querySelector('.card-overlay-centered') !== null;
  });

  if (!gridsWithCardOverlay) return;

  gridsWithCardOverlay.forEach(container => {
    const cards = container.querySelectorAll('.card-overlay-centered');
    let maxDescriptionHeight = 0;

    cards.forEach(card => {
      const description = card.querySelector('.uk-card-description');

      const descriptionHeight = description.clientHeight;

      if (descriptionHeight > maxDescriptionHeight) {
        maxDescriptionHeight = descriptionHeight;
      }
    });

    cards.forEach(card => {
      const textWrappers = card.querySelectorAll('.uk-card-body');

      textWrappers.forEach(textWrap => {
        textWrap.style.paddingTop = `calc(75% - ${maxDescriptionHeight}px + 30px)`;
      });
    });
  });
};

UIkit.util.on(document, 'shown', function (e) {
  if (e.target.matches('[data-accordion-item]')) {
    const slideshows = e.target.querySelectorAll('[uk-slideshow]');
    slideshows.forEach(slideshow => {
      UIkit.slideshow(slideshow).show(0);
    });
  }
});

const slideWrappers = document.querySelectorAll('.slide-wrapper');

if (slideWrappers.length > 0) {
  slideWrappers.forEach(wrapper => {
    if (!wrapper.__uikitInitialized) {
      UIkit.slideshow(wrapper, {
        animation: 'fade',
        draggable: false,
        minHeight: 200,
        maxHeight: 200,
      });

      wrapper.__uikitInitialized = true;
    }
  });
}

function uppercasePhiniaText(node) {
  if (node.nodeType === Node.TEXT_NODE) {
    node.nodeValue = node.nodeValue.replace(/Phinia/g, 'PHINIA');
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    for (let child of node.childNodes) {
      uppercasePhiniaText(child);
    }
  }
}

uppercasePhiniaText(document.body);

initMainNavigation();
initInfographicCards();
initMegamenu();
initAccordionCards();
initNewsSlideshow();
initAutotyping();
initRolodexSlideshow();

window.addEventListener('resize', initInfographicCards);
calcOverlayCenteredCardPadding();

document.addEventListener('DOMContentLoaded', initAnimations);

const dropdownCloseButtonsSmallIcons =
  document.querySelectorAll('.uk-dropdown-close');

if (dropdownCloseButtonsSmallIcons) {
  dropdownCloseButtonsSmallIcons.forEach(button => {
    button.addEventListener('click', () => {
      const dropdown = button.closest('[uk-dropdown]');
      if (dropdown) {
        UIkit.dropdown(dropdown).hide(0);
      }
    });
  });
}

window.addEventListener('load', () => {
  const hotspots = document.querySelectorAll('.hotspot');

  if (hotspots) {
    hotspots.forEach(hotspot => {
      if (hotspot) {
        hotspot.style.display = 'block';
      }
    });
  }
});

const { getComponent, util } = UIkit;
const { getIndex, on, ready } = util;

ready(() => {
  setTimeout(() => {
    const slideshow = $('#slideshow');
    const sliderComp = getComponent($('#thumb-nav'), 'slider');

    let counters = document.querySelectorAll('.counter');

    counters.forEach(counter => {
      const currentSlidershowWrapper = counter.closest('#slideshow');

      const firstActive = currentSlidershowWrapper.querySelector(
        '.uk-active.uk-first-column'
      );

      if (!firstActive) return;

      counter.innerText = firstActive.getAttribute('aria-label');
    });

    on(slideshow, 'itemshow', ({ detail, target }) => {
      if (target.getAttribute('uk-slideshow-item')) {
        counters.forEach(counter => {
          const currentSlidershowWrapper = counter.closest('#slideshow');

          if (currentSlidershowWrapper.contains(target)) {
            counter.innerText = target.getAttribute('aria-label');
          } else {
            counter.innerText = '0';
          }
        });
      }

      if (detail[0].$el === slideshow) {
        if(sliderComp) sliderComp.show(getIndex(target, target.parentNode.children));
      }
    });
  }, 500);
});

document.addEventListener('DOMContentLoaded', function () {
  const urlParams = new URLSearchParams(window.location.search);
  if (!urlParams.has('sf_cntrl_id')) return;

  const successMessage = document.querySelector('.sf-form-section');
  if (successMessage && successMessage.offsetParent !== null) {
    if (window.rolodexHeroInstance && window.rolodexHeroInstance.lenis) {
      //
    } else {
      successMessage.scrollIntoView({ behavior: 'smooth' });
    }
  }
});

const nav = document.querySelector('.link-inpage-navigation');

if (nav) {
  const updateFade = () => {
    
    const scrollLeft = nav.scrollLeft;
    const maxScroll = nav.scrollWidth - nav.clientWidth;

    nav.classList.toggle('is-scroll-started', scrollLeft > 0);

    nav.classList.toggle('is-at-end', scrollLeft >= maxScroll - 1);
  };

  nav.addEventListener('scroll', updateFade);
  window.addEventListener('resize', updateFade);

  updateFade();
}

const megamenuAccordions = document.querySelectorAll('.megamenu-accordion');

megamenuAccordions.forEach(accordion => {

  accordion.addEventListener('click', () => {
    const accordionGroupWrapper = accordion.closest('.uk-active');
    if(!accordion.querySelector('.uk-open')) {
      const activeAccordion = accordionGroupWrapper.querySelector(
        '.megamenu-accordion:has(.uk-open)'
      );

      UIkit.accordion(activeAccordion).toggle(0);
    }
  })
});


document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.lazy-video');

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target;
          video.src = video.dataset.src; // start loading
          observer.unobserve(video);
        }
      });
    },
    { 
      rootMargin: '500px 0px', // triggers 500px before viewport
      threshold: 0
    }
  );

  videos.forEach(video => observer.observe(video));

  document.querySelectorAll('.new-card__wrapper--content__features-benefits').forEach(ul => {
    const lis = ul.querySelectorAll('li');
    lis.forEach((li, index) => {
      if (index < 6) {
        li.style.display = 'block';
      }
    });
  });
});